module.exports = __webpack_public_path__ + "static/media/ucas_official.fa6c6e89.jpg";